<template>
  <div class="code-container" :class="data.status" >
    <div class="text-code" >{{ data.code }}</div>
    <div class="footer" >{{ timeElapsed }}</div>
    <div class="footer-date" >วันที่เพิ่ม: {{ dateTimeConvert(data.created_at) }}</div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name:"CodeBlock",
  props:["status","data"],
  data() {
    return {
      timeElapsed: ''
    }
  },
  methods:{
    dateTimeConvert(date){
      moment.locale('th');
      const formattedDate = moment(date).format('MMMM Do YYYY, H:mm:ss');
      const buddhistYear = moment(date).year() + 543;  // Calculate the BE year
      return formattedDate.replace(moment(date).year(), buddhistYear);
    },
    dateConvert() {
      const data = this.data;
      // Clear any existing intervals to prevent memory leaks
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

      // Start the interval and store the interval ID
      this.intervalId = setInterval(() => {
        let result = '';
        let result_all = '';

        if(data){
          if (data.status === "active") {
            const dateNow = moment();
            const diff = moment(dateNow).diff(moment(data.start));
            const duration = moment.duration(diff);

            const days = Math.floor(duration.asDays());
            const hours = Math.floor(duration.asHours() % 24);
            const minutes = Math.floor(duration.asMinutes() % 60);

            if (days > 0 && hours > 0 && minutes > 0) {
              result = `${days} วัน ${hours} ชั่วโมง ${minutes} นาที`;
            } else if (days > 0 && hours > 0) {
              result = `${days} วัน ${hours} ชั่วโมง`;
            } else if (days > 0) {
              result = `${days} วัน`;
            } else if (hours > 0 && minutes > 0) {
              result = `${hours} ชั่วโมง ${minutes} นาที`;
            } else if (hours > 0) {
              result = `${hours} ชั่วโมง`;
            } else {
              result = `${minutes} นาที`;
            }


            if (data.hour >= 24) {
              const days = Math.floor(data.hour / 24);
              const remainingHours = data.hour % 24;

              if (days > 0 && remainingHours > 0) {
                result_all = `${days} วัน ${remainingHours} ชั่วโมง`;
              } else if (days > 0) {
                result_all = `${days} วัน`;
              } else {
                result_all = `${data.hour} ชั่วโมง`;
              }
            } else {
              result_all = `${data.hour} ชั่วโมง`;
            }

          } else {
            if (data.hour >= 24) {
              const days = Math.floor(data.hour / 24);
              const remainingHours = data.hour % 24;

              if (days > 0 && remainingHours > 0) {
                result_all = `${days} วัน ${remainingHours} ชั่วโมง`;
              } else if (days > 0) {
                result_all = `${days} วัน`;
              } else {
                result_all = `${data.hour} ชั่วโมง`;
              }
            } else {
              result_all = `${data.hour} ชั่วโมง`;
            }
          }
        }


        // Update the reactive timeElapsed property
        if (data.status === "active") {
          this.timeElapsed = result+"/"+result_all;
        }else{
          this.timeElapsed = result_all;
        }

      }, 1000);
    },
  },
  mounted() {
    this.dateConvert();
  }
}
</script>
<style scoped>
.code-container{
  width: 90%;
  border-radius: 1rem;
  padding: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
.code-container .text-code{
  font-size: 4rem;
  font-weight: bold;
}

.code-container .footer{
  font-size: 1rem;
  text-align: right;
}
.code-container .footer-date{
  font-size: 0.6rem;
  text-align: right;
}
.wait{
  background: #bbc2cc;
  color: black;
  border: 3px solid #797c7f;
}
.active{
  background: #0bde00;
  color: #ffffff;
  border: 3px solid #17ba0f;
}
.expire{
  background: #f41a33;
  color: #ffffff;
  border: 3px solid #c50017;
}
</style>
